import React from 'react';
import styled from 'styled-components';
import { ILessonOutlineCycleActivityPanel } from '../../../../types/lessonOutline';
import { positionLessonToString } from '../../../../helpers/positon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { CLIconWrapper } from './LessonOutlineActivityVoc';

export type IProps = {
  activity: ILessonOutlineCycleActivityPanel;
};

const LessonOutlineActivityPanel: React.FC<IProps> = (props) => {
  return (
    <Wrapper>
      {props.activity.repeated && (
        <CLIconWrapper>
          <FontAwesomeIcon icon={faExclamation} />
        </CLIconWrapper>
      )}
      {props.activity.position && <span>{positionLessonToString(props.activity.position.lesson)} - </span>}
      <span dangerouslySetInnerHTML={{ __html: props.activity.title }} />
    </Wrapper>
  );
};

export default LessonOutlineActivityPanel;

const Wrapper = styled.div`
  background-color: #fff6d8;
  padding: 4px 2px;
  border-radius: 4px;
`;
